module.exports = __webpack_public_path__ + "static/media/logo.82260fc5.svg";